module.exports = __webpack_public_path__ + "img/leads.aaf5ce17.svg";